import { axiosPrivate } from "./axios";

export const aboutusByApi = async (payloadData) => {
  let res = await axiosPrivate.get("/frontend/aboutus", payloadData);
  return res.data;
};
